import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "backdrop"]

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  open(event) {
    event?.preventDefault()
    this.menuTarget.classList.add("open")
    this.backdropTarget.classList.add("open")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    event?.preventDefault()
    this.menuTarget.classList.remove("open")
    this.backdropTarget.classList.remove("open")
    document.body.style.overflow = ""
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  backdropClick(event) {
    if (event.target.classList.contains("slide-menu-backdrop")) {
      this.close()
    }
  }
}
